<template>
  <component class="timeline_record px-3 bd-radius"
    :is="award.url ? 'a' : 'div'"
    :class="award.url ? 'list-bg' : ''"
    v-tooltip.right="{
      content: getContent,
      container: 'body',
      boundariesElement: 'body',
      delay: { show: 300, hide: 300 },
      autoHide: false,
      classes: ['filter-card-tooltip']
    }"
    :href="award.url ? award.url : ''"
    target="_blank"
  >
    <div class="timeline_record--left pr-3 t-secondary min-height--65px">
      <div v-if="award.category || award.year">
        <p class="mb-0" v-if="award.category">{{ award.category }}</p>
        <p class="mb-0" v-if="award.year">{{ award.year }}</p>
      </div>
    </div>
    <div class="timeline_record--right px-3 pb-3 min-height--65px">
      <p class="mb-0 t-600">
        {{ award.name }}
      </p>
      <template v-if="!isEmpty(award.country)">
        <p class="mb-0 t-xs t-600 t-primary">Organising Country</p>
        <p class="mb-0 t-xs t-primary">
          <flag :title="renderCountryFlagTooltip(award.country)" :iso="award.country.alpha_2 | lowercase" :squared="false" class="flag bd-radius t-sm mr-1" />
          <span>{{ award.country.name }}</span>
        </p>
      </template>
    </div>
  </component>
</template>

<script>
export default {
  name: 'award',
  props: {
    award: {
      type: Object,
      required: true
    }
  },
  computed: {
    getContent () {
      let output = ''
      if (this.award.description) {
        if (this.award.url) {
          output += `<a class="t-700" href="${this.award.url}" target="_blank">${this.award.name}</a>`
        } else {
          output += `<p class="t-700">${this.award.name}</p>`
        }
        output += `<p class="my-1 position-relative t-primary t-sm">${this.award.description}</p>`
      }
      return output
    }
  }
}
</script>
